import React from "react";
import { createRoot } from 'react-dom/client';
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import App from './App';
import theme from "./themes/theme";
import { CssBaseline } from '@mui/material';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./common/msalClient";
import { AuthProvider } from "./common/auth.context";

const container = document.querySelector("#root");
const root = createRoot(container);
root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </MsalProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);